module.exports = __webpack_public_path__ + "img/beach-access_outlined.de54c8ce.svg";